/**
 * @description Module header
 */

/* global bsBreakpoints */

(() => {
	// Const menu
	const header = document.querySelector('[data-js-header]');
	const headerMenu = document.querySelector('[data-js-header-nav]');
	const headerMenuDesktop = document.querySelector(
		'[data-js-header-menu-desktop]'
	);
	const headerMenuRWD = document.querySelector('[data-js-header-menu-rwd]');
	const headerMenuToggle = document.querySelector(
		'[data-js-header-menu-toggle]'
	);
	const headerMenuPrevious = document.querySelectorAll(
		'[data-js-header-menu-previous]'
	);

	// Const Li menu
	const liExpanded = document.querySelectorAll('.leaf-lvl-1.expanded');

	const expanded = document.querySelectorAll(
		'.expanded .header__menu__expanded'
	);

	// Const account
	const headerAccountToggle = document.querySelector(
		'[data-js-header-account-toggle]'
	);

	// Variable d'environnement nécessaire à l'utilisation des breakpoints
	const body = document.querySelector('body');

	// FUNCTIONS

	// Comportement au scroll
	const scrollHeader = () => {
		const carto = document
			.querySelector('body')
			.classList.contains('cartographie'); // permet de detecter la page carto
		document.onscroll = function () {
			if (!carto) {
				// si c'est pas une carto on active le sticky header
				if (window.pageYOffset > 40) {
					header.classList.add('scrolled');
				} else {
					header.classList.remove('scrolled');
				}
			} else {
				if (
					window.pageYOffset > 40 &&
					document.querySelector('main').offsetHeight >
						window.innerHeight
				) {
					header.classList.add('scrolled');
				} else {
					header.classList.remove('scrolled');
				}
			}
		};
	};
	// fixe le body à l'activation du menu
	const fixeBody = () => {
		document
			.querySelector('.header__menu__toggle')
			.addEventListener('click', () => {
				if (
					document
						.querySelector('.header__menu__toggle')
						.classList.contains('active')
				) {
					document.querySelector('body').style.overflow = 'auto';
				} else {
					document.querySelector('body').style.overflow = 'hidden';
				}
			});
	};

	// Affiche dynamiquement le titre du sous menu en mobile
	const navRWD = () => {
		expanded.forEach(function (btn) {
			btn.addEventListener('click', function () {
				const parent = btn.closest('li');
				// Sous menu actif
				const submenu = btn.nextElementSibling;
				// Récupérer et afficher le titre du sous menu actif
				const title = btn.previousElementSibling.text;

				submenu.children[0].children[1].innerHTML = title;

				parent.classList.toggle('active');
				submenu.classList.toggle('active');
			});
		});
	};

	// Affiche ou retire le titre du sous menu
	const goPrevious = function goPrevious() {
		headerMenuPrevious.forEach(function (prev) {
			const parent = prev.closest('.header__menu__submenu');
			prev.addEventListener('click', function () {
				// Retire le titre du sous-menu
				// eslint-disable-next-line no-unused-vars
				const submenutitle = prev.previousElementSibling;
				// submenutitle.parentNode.removeChild(submenutitle);
				// Remove le sous-menu actif
				parent.classList.remove('active');
			});
		});
	};

	// Menu responsive
	const menuRwd = () => {
		if (
			bsBreakpoints.detectBreakpoint() === 'xSmall' ||
			bsBreakpoints.detectBreakpoint() === 'small' ||
			bsBreakpoints.detectBreakpoint() === 'medium'
		) {
			headerMenuRWD.appendChild(headerMenu);
		}
		if (
			bsBreakpoints.detectBreakpoint() === 'xLarge' ||
			bsBreakpoints.detectBreakpoint() === 'large'
		) {
			headerMenuDesktop.appendChild(headerMenu);
		}
	};

	// Gère le déplacement du menu en fonction du périphérique
	const toggleMenu = function toggleMenu() {
		headerMenuToggle.addEventListener('click', function () {
			headerMenuRWD.appendChild(headerMenu);
			headerMenuToggle.classList.toggle('active');
			if (headerMenuToggle.getAttribute('aria-expanded') === 'true') {
				headerMenuToggle.setAttribute('aria-expanded', 'false');
			} else {
				headerMenuToggle.setAttribute('aria-expanded', 'true');
			}
			headerMenuRWD.classList.toggle('active');
		});
	};

	// Account
	const menuAccount = function menuAccount() {
		if (headerAccountToggle) {
			headerAccountToggle.addEventListener('click', function () {
				headerAccountToggle.classList.toggle('active');
			});
		}
	};

	const A11Y = () => {
		liExpanded.forEach((hasPopup) => {
			if (hasPopup) {
				hasPopup.querySelector('a').setAttribute('aria-haspopup', true);
			}

			hasPopup.addEventListener('keyup', (event) => {
				if (event.code === 'Escape') {
					hasPopup.querySelector(
						'.header__menu__submenu'
					).style.display = 'none';
				}
				event.stopPropagation();
			});
		});
	};

	// GO après chargement 🚀

	window.addEventListener('load', function () {
		if (document.body.contains(header)) {
			scrollHeader();
			fixeBody();
			navRWD();
			goPrevious();
			menuRwd();
			toggleMenu();
			menuAccount();
			A11Y();
		}
		window.onresize = function () {
			menuRwd();
		};
	});
})();
